<template>
  <button
    class="paper-button"
    :type="type"
    :disabled="disabled"
  >
    <slot /></button>
</template>

<script>
export default {
  name: "heim-button",
  props: {
    type: {
      type: String
    },
    disabled: Boolean
  }
};
</script>

<style scoped>
button.paper-button {
  border: none;
  padding: 0.5em 1em;
  text-align: center;
  min-width: 5em;
  border-radius: 3px;
  font-weight: 600;
  font-size: 1rem;
  color: #ffffff;
  background-color: var(--heim-secondary-color);
  cursor: pointer;
  outline: none;
  text-transform: capitalize;
}
button.cancel-button {
  color: var(--heim-secondary-color);
  background-color: var(--heim-whit-color);
  cursor: pointer;
}
button.paper-button:hover,
button.paper-button:focus {
  box-shadow: var(--heim-shadow);
}

button.paper-button:disabled {
  background: grey;
}
</style>
